<div class="document-card-container">
  @for (document of currentPage().data; track document) {
    <div class="card" [attr.aria-label]="document.documentTitle">
      <div class="card--icon" [style.background-image]="'url(' + document.iconUrl + ')'">
        @if (document.isGenericIcon) {
          <p>{{document.fileExtension}}</p>
        }
      </div>
      <div class="card--text">
        <div class="card--text__primary"><p>{{document.documentTitle}}</p></div>
        <div class="card--text__secondary">
          <div class="document-uploaded-datetime">{{document.uploadedDateTimeString}}</div>
        </div>
      </div>
      <div class="card--download-button">
        <button (click)="buttonClicked.emit(document)" [attr.aria-label]="document.downloadButtonLabel">{{document.downloadButtonText}}</button>
      </div>
      <button class="card--download-icon" (click)="buttonClicked.emit(document)" [attr.aria-label]="document.downloadButtonLabel">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path class="arrow" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
        </svg>
      </button>
    </div>
  }
</div>
